"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
String.prototype.toColor = function () {
    let hash = 0;
    let i;
    /* eslint-disable no-bitwise */
    for (i = 0; i < this.length; i += 1) {
        hash = this.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */
    return color;
};
String.prototype.rUpper = function () {
    return this.toLowerCase()
        .replace(/(^\w{1})|([\s'.:;]+(?!\s*(de|da|do)s?\s)\w{1})/g, (letra) => letra.toUpperCase())
        .replace(/((^|[\s])M{0,4}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})([\s]|$))/gi, (romano) => romano.toUpperCase());
};
String.prototype.stripTags = function () {
    return this.replace(/<[^>]*>/gi, '');
};
String.prototype.removerAcentos = function () {
    return this.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
